import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/whatsapp";

const ContentCTA = () => {
  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-8">
            Conocer estos tres pilares es el primer paso. Sin embargo, cada industria es distinta y aplicar estas herramientas requiere un{" "}
            <span className="text-foreground font-semibold">análisis profundo</span> de lo que tu marca proyecta hoy.
          </p>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-12">
            Si lideras una marca consolidada y estás listo para dejar de competir por precio y reclamar el{" "}
            <span className="text-foreground font-semibold">lugar N°1 de tu mercado</span>, hacé clic en el botón de abajo para agendar un Pre-diagnóstico sin costo. En esta sesión de 15 minutos analizaremos tu brecha de percepción actual y definiremos si podemos acompañarte a alcanzar tus resultados en los próximos 90 días.
          </p>

          <motion.a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
            className="inline-flex items-center gap-3 px-10 py-5 bg-primary text-primary-foreground font-bold text-lg rounded-full shadow-xl hover:shadow-2xl transition-shadow group"
          >
            SOLICITAR MI PRE-DIAGNÓSTICO AHORA
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ContentCTA;
